// ✅ parseTags.js — Auto-link @mentions and #hashtags

/**
 * Converts plain text with @mentions and #hashtags to HTML anchor tags
 * @param {string} text
 * @returns {string} HTML string with clickable tags
 */
export default function parseTags(text) {
    if (!text) return '';
  
    const mentionRegex = /@(\w+)/g;
    const hashtagRegex = /#(\w+)/g;
  
    return text
      .replace(mentionRegex, (match, user) => {
        return `<a href='/profile/${user}' class='text-blue-700 hover:underline font-semibold'>@${user}</a>`;
      })
      .replace(hashtagRegex, (match, tag) => {
        return `<a href='/jan-sabha?tag=${tag}' class='text-green-700 hover:underline font-semibold'>#${tag}</a>`;
      });
  }
  